import React, { useState, useEffect, ReactNode } from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { ThemeProvider, makeStyles } from "@material-ui/core/styles";
import theme from "./theme";
import { Container } from "@material-ui/core";
import { SnackbarAlert, Loading } from "~/components";
import { RootState } from "~/redux/rootReducer";
import { Header } from "./components/header";

type Props = {
  children: ReactNode;
  loading?: boolean; // ローディング中かどうか
  errorMessage?: string; // エラーメッセージ
  successMessage?: string; // サクセスメッセージ
};

export const Layout: React.VFC<Props> = (props) => {
  const classes = useStyles();

  // global state
  const { isInit, loading } = useSelector(
    (state: RootState) => state.specialistAuth
  );
  const isMasterInit = useSelector((state: RootState) => state.master.isInit);

  // 全てロード完了しているかどうか
  const isLoaded = !loading && isMasterInit;

  // アラート
  const [error, setError] = useState<boolean>(false);
  useEffect(() => {
    if (props.errorMessage) setError(true);
  }, [props.errorMessage]);
  const [success, setSuccess] = useState<boolean>(false);
  useEffect(() => {
    if (props.successMessage) setSuccess(true);
  }, [props.successMessage]);

  if (isInit) {
    return (
      <ThemeProvider theme={theme}>
        <Helmet>
          <title>SHUZO 専門家情報登録/編集サイト</title>
        </Helmet>

        {/* ヘッダー */}
        <Header />

        {/* コンテンツ */}
        <Container className={classes.container} maxWidth="md">
          <div>{props.children}</div>
        </Container>

        {/* アラート表示 */}
        <SnackbarAlert
          open={error}
          onClose={() => setError(false)}
          message={props.errorMessage}
        />
        <SnackbarAlert
          open={success}
          onClose={() => setSuccess(false)}
          message={props.successMessage}
          type="success"
        />

        {/* ローディング */}
        <Loading open={props.loading === true || !isLoaded} />
      </ThemeProvider>
    );
  } else {
    return <Loading open />;
  }
};

const useStyles = makeStyles({
  container: {
    textAlign: "center",
    paddingTop: 64,
  },
});
